import { useCallback } from "react";
import { toast } from "../lib/toast";

export type Msg = { type: "ok" | "err"; text: string } | null;

/**
 * Drop-in replacement for the per-page `const [msg, setMsg] = useState(...)`
 * + inline card pattern. `setMsg({ type: "ok", text })` now shows a global
 * fixed toast (visible regardless of scroll position) instead of a card at
 * the top of the page. `setMsg(null)` is a no-op.
 */
export function useMsg(): (m: Msg) => void {
  return useCallback((m: Msg) => {
    if (m) toast(m.type, m.text);
  }, []);
}
